const NAV_LINKS = [
  { label: 'TOP', href: '#top' },
  { label: '買取品目一覧', href: '#categories' },
  { label: '買取方法', href: '#howto' },
  { label: '会社概要', href: '#about' },
  { label: 'よくある質問', href: '#faq' },
  { label: 'お問い合わせ', href: '#contact' },
];

const Footer = () => {
  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 72, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#2F3630] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <p className="font-bold text-xl tracking-wider mb-2 whitespace-nowrap" style={{ fontFamily: "'Shippori Mincho', serif" }}>
              株式会社OTAKE
            </p>
            <p className="text-[#B2AC88] text-xs tracking-widest mb-4">OTAKE CORPORATION</p>
            <p className="text-[#B2AC88]/60 text-sm leading-relaxed mb-5">
              岡山市中区を拠点に、貴金属・腕時計・ブランド品・家電・家具・記念硬貨・切手など
              幅広い品目の高価買取を行っています。地球にやさしい循環型リユースで
              あなたの大切な品物に新しい価値を。
            </p>
            <div className="flex flex-col gap-1 text-sm">
              <p className="text-[#B2AC88]/60">
                <i className="ri-map-pin-line mr-2 text-[#B2AC88]" />
                岡山県岡山市中区倉田652番地15
              </p>
              <a href="tel:086-238-7864" className="text-[#B2AC88]/60 hover:text-white transition-colors whitespace-nowrap">
                <i className="ri-phone-line mr-2 text-[#B2AC88]" />
                086-238-7864
              </a>
              <p className="text-[#B2AC88]/60">
                <i className="ri-time-line mr-2 text-[#B2AC88]" />
                9:00〜17:00（土・日・祝除く）
              </p>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-xs font-bold tracking-widest uppercase text-[#B2AC88] mb-5">Navigation</p>
            <ul className="flex flex-col gap-3">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollTo(e, link.href)}
                    className="flex items-center gap-2 text-[#B2AC88]/60 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-[#B2AC88] text-base" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact CTA */}
          <div>
            <p className="text-xs font-bold tracking-widest uppercase text-[#B2AC88] mb-5">Contact</p>
            <div className="bg-[#B2AC88]/20 rounded-2xl p-6">
              <p className="text-white font-bold text-sm mb-1">無料査定・お問い合わせ</p>
              <p className="text-[#B2AC88]/60 text-xs mb-4 leading-relaxed">
                査定無料・即日対応。まずはお気軽にご連絡ください。
              </p>
              <a
                href="tel:086-238-7864"
                className="flex items-center justify-center gap-2 bg-[#D97706] hover:bg-[#c06a05] text-white font-bold py-3 rounded-full text-sm transition-colors whitespace-nowrap mb-3"
              >
                <i className="ri-phone-fill" />
                086-238-7864
              </a>
              <a
                href="#contact"
                onClick={(e) => scrollTo(e, '#contact')}
                className="flex items-center justify-center gap-2 border border-white/30 hover:border-white/60 text-white text-sm py-3 rounded-full transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-send-line" />
                フォームで相談
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[#B2AC88]/50 text-xs">
            &copy; 2025 株式会社OTAKE. All rights reserved.
          </p>
          <p className="text-[#B2AC88]/50 text-xs">
            古物商許可証 岡山県公安委員会許可
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
